import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';
import { Button } from 'antd';
import Translate from 'react-translate-component';

import ModalContainer from 'components/modals/ModalContainer';
import { modalPropTypes } from 'components/Modals';
import { putScenarioBookRead } from 'actions/asyncActions';
import { generateBookFileUrl } from 'constants/urls';
import { openState } from 'constants/scenario';

@asyncConnect({
    putScenarioBookRead: putScenarioBookRead
        .withSuccessHandler(({ close }) => close())
})
export default class ScenarioBookModal extends Component {
    static propTypes = {
        ...modalPropTypes,
        params: PropTypes.shape({
            cmd: PropTypes.string.isRequired,
            token: PropTypes.string.isRequired,
            stageItem: PropTypes.object.isRequired
        }),
        putScenarioBookRead: PropTypes.object.isRequired
    }

    render() {
        const { modal, params: { stageItem, cmd, token }, putScenarioBookRead: { dispatch: markAsRead, meta } }  = this.props;

        return (
            <ModalContainer
                modal={{ ...modal, width: 550 }}
                meta={meta}
                title={stageItem.name}
                className="scenario-read-modal"
            >
                <div className="text-right">
                    <Button href={generateBookFileUrl(stageItem.id, cmd, token)}>
                        <Translate content="documents.download" />
                    </Button>
                    { stageItem.state === openState &&
                        <Button disabled={meta.pending} onClick={() => markAsRead(stageItem.id)} type='blue' className="m-l-5">
                            <Translate content="education.scenario.markAsRead"/>
                        </Button>
                    }
                </div>
            </ModalContainer>
        )
    }
}
